export default "__VITE_ASSET__BXjGAo2t__"